// extracted by mini-css-extract-plugin
export default {"container":"uA-z","dimension":"vA-z","dimensionLabels":"wA-z"};